import _toConsumableArray from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * Observable class prototype.
 *
 * @module observable
 */
import * as map from './map.js';
import * as set from './set.js';
import * as array from './array.js';
/**
 * Handles named events.
 *
 * @template N
 */

export var Observable =
/*#__PURE__*/
function () {
  function Observable() {
    _classCallCheck(this, Observable);

    /**
     * Some desc.
     * @type {Map<N, any>}
     */
    this._observers = map.create();
  }
  /**
   * @param {N} name
   * @param {function} f
   */


  _createClass(Observable, [{
    key: "on",
    value: function on(name, f) {
      map.setIfUndefined(this._observers, name, set.create).add(f);
    }
    /**
     * @param {N} name
     * @param {function} f
     */

  }, {
    key: "once",
    value: function once(name, f) {
      var _this = this;

      /**
       * @param  {...any} args
       */
      var _f = function _f() {
        _this.off(name, _f);

        f.apply(void 0, arguments);
      };

      this.on(name, _f);
    }
    /**
     * @param {N} name
     * @param {function} f
     */

  }, {
    key: "off",
    value: function off(name, f) {
      var observers = this._observers.get(name);

      if (observers !== undefined) {
        observers.delete(f);

        if (observers.size === 0) {
          this._observers.delete(name);
        }
      }
    }
    /**
     * Emit a named event. All registered event listeners that listen to the
     * specified name will receive the event.
     *
     * @todo This should catch exceptions
     *
     * @param {N} name The event name.
     * @param {Array<any>} args The arguments that are applied to the event listener.
     */

  }, {
    key: "emit",
    value: function emit(name, args) {
      // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
      return array.from((this._observers.get(name) || map.create()).values()).forEach(function (f) {
        return f.apply(void 0, _toConsumableArray(args));
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._observers = map.create();
    }
  }]);

  return Observable;
}();